<template>
    <c-dialog ref="dialog" mode="slide" width="85vw" enable-flex mask-close>
        <module>
            <module-col size="300">
                <c-detail class="m-detail-form">
                    <c-detail-item label="采购单号">
                        {{detailData.purchase_code}}
                    </c-detail-item>
                    <c-detail-item label="采购数(台)">
                        {{detailData.purchase_count}}
                    </c-detail-item>
                    <c-detail-item label="数据统计">
                        收 {{detailData.purchase_product_count}}
                        验 {{detailData.checked_count}}
                        退 {{detailData.return_count}}
                    </c-detail-item>
                    <c-detail-item label="采购渠道">
                        <c-state tag async dict="PURCHASE_CHANNEL" :value="detailData.purchase_channel"></c-state>
                    </c-detail-item>
                    <c-detail-item label="售卖人">
                        {{detailData.seller_name}}
                    </c-detail-item>
                    <c-detail-item label="售卖人手机号">
                        {{detailData.seller_phone}}
                    </c-detail-item>
                    <c-detail-item label="售卖地址">
                        {{detailData.seller_address}}
                    </c-detail-item>
                    <c-detail-item label="快递单号">
                        {{detailData.express_no||'-'}}
                    </c-detail-item>
                    <c-detail-item label="仓库">
                        {{detailData.store_name||'-'}}
                    </c-detail-item>
                    <c-detail-item label="创建时间">
                        {{detailData.create_date||'-'}}
                    </c-detail-item>
                </c-detail>
            </module-col>
            <module-col tab-type="border-tab">
                <c-form ref="purchaseForm">
                    <c-form link-parent>
                        <c-form-item label="采购数" required tip="请填写实际收货的商品数量">
                            <c-input name="purchase_product_count" v-model="purchase_product_count" type="number" decimal="0"
                                     :range="[1,9999]" append-text="件"></c-input>
                        </c-form-item>
                    </c-form>
                </c-form>
                <module-tab name="采购商品" enable-flex>
                    <m-operate border>
                        <c-button color="main" v-if="auth('b_online_purchase_order_edit')"
                                  prepend-icon="tf-add" @click="addRow()" :disabled="!canAddCode">添加一行
                        </c-button>
<!--                        <c-button color="main" :hollow="true" v-if="auth('b_online_purchase_order_edit')"
                                  prepend-icon="tf-search" @click="openImeiFactoryQuery()">查询IMEI出厂信息
                        </c-button>-->
                        <c-input ref="codeInput" v-model="scanCode" placeholder="请输入/扫描背贴码"
                                 @keyup.enter.native="scanHandle" :disabled="!canAddCode" style="width: 200px;">
                            <template #appendIcon><i class="tf-scan"></i></template>
                        </c-input>
                        <c-button color="main" @click="scanHandle" :disabled="!canAddCode">确定</c-button>
                    </m-operate>
                    <c-table ref="productTable" border :paging="false">
                        <c-table-column label="状态" width="65" required>
                            <template #default="{data}">
                                <span v-if="!data.id" style="color: red">待保存</span>
                                <span v-else>
                                  <!-- purchase_state 采购状态：1-待收货；2-质检中；3-待确认；4-已确认；5-待退回；6-已退回',-->
                                  <span v-if="data.purchase_state == 2" style="color: blue">质检中</span>
                                  <span v-else-if="data.purchase_state == 3" style="color: brown">待确认</span>
                                  <span v-else-if="data.purchase_state == 4" style="color: green">已确认</span>
                                  <span v-else-if="data.purchase_state == 5" style="color: red">待退回</span>
                                  <span v-else-if="data.purchase_state == 6" style="color: gray">已退回</span>
                                </span>
                            </template>
                        </c-table-column>
                        <c-table-column label="初检状态" width="80">
                            <template #default="{data}">
                                <span v-if="data.inspection_state == 2" style="color: blue">已初检</span>
                                <span v-else style="color: red">待初检</span>
                            </template>
                        </c-table-column>
                        <c-table-column label="背贴码" width="180" required>
                            <template #default="{data}">
                                <c-input type="hidden" name="inspection_state" v-model="data.inspection_state"></c-input>
                                <c-input name="produce_unique_code" v-model="data.produce_unique_code" maxlength="30"
                                         :disabled="!data.editable"
                                         @input="clearCodeError(data)"
                                         @enter="checkProductCode(data)"
                                         @change="checkProductCode(data)"></c-input>
                                <div class="m-code-error-tip" v-if="data.code_error">{{data.code_error}}</div>
                            </template>
                        </c-table-column>
                        <c-table-column label="IMEI码" width="185" required>
                            <template #default="{data}">
                                <c-input name="produce_imei" v-model="data.produce_imei" maxlength="30"
                                         :disabled="!data.editable">
                                    <template #append>
                                        <a v-if="data.editable" class="m-gen-imei" :class="{'z-dis': data.imei_generating}"
                                           @click="generateImei(data)">生成</a>
                                    </template>
                                </c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="分类" width="100" required>
                            <template #default="{data}">
                                <c-select name="category_id"
                                          async @search="searchCategory"
                                          @change="changeSelect($event, data,'categoryId')"
                                          :value-data="data.productCategory"
                                          v-model="data.category_id"
                                          :disabled="!data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="品牌" width="100" required>
                            <template #default="{data}">
                                <c-select name="brand_id"
                                          async @search="searchBrand(data,arguments[0], arguments[1])"
                                          @change="changeSelect($event, data,'brandId')"
                                          :value-data="data.productBrand"
                                          v-model="data.brand_id"
                                          :disabled="!data.category_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="机型" width="180" required>
                            <template #default="{data}">
                                <c-select name="spu_model_id"
                                          async @search="searchModel(data,arguments[0], arguments[1])"
                                          @change="changeSelect($event, data,'modelId')"
                                          :value-data="data.productModel"
                                          v-model="data.spu_model_id"
                                          :disabled="!data.brand_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="内存" width="100" required>
                            <template #default="{data}">
                                <c-select name="memory_id"
                                          async @search="searchSpuAttribute(data,'storage', arguments[0], arguments[1])"
                                          :value-data="data.productMemory"
                                          v-model="data.memory_id"
                                          :disabled="!data.spu_model_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="颜色" width="120" required>
                            <template #default="{data}">
                                <c-select name="color_id"
                                          async @search="searchSpuAttribute(data,'color', arguments[0], arguments[1])"
                                          :value-data="data.productColor"
                                          v-model="data.color_id"
                                          :disabled="!data.spu_model_id || !data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="等级" width="100" required>
                            <template #default="{data}">
                                <c-select name="level_type"
                                          async @search="searchDicInfo('LEVEL_TYPE', arguments[0], arguments[1])"
                                          :value-data="data.productLevel"
                                          v-model="data.level_type"
                                          :disabled="!data.editable"
                                          :clear="false">
                                    <template #option="{data, selected}">
                                        <select-option :name="data.name" :selected="selected"></select-option>
                                    </template>
                                </c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="演示机" width="110">
                            <template #default="{data}">
                                <c-select name="is_demo" :options="yesOrNoOptions"
                                          v-model="data.is_demo"
                                          :disabled="!data.editable"
                                          :clear="false"></c-select>
                            </template>
                        </c-table-column>
                        <c-table-column label="外部订单号" width="100">
                            <template #default="{data}">
                                <c-input name="out_order_number" v-model="data.out_order_number" maxlength="30"
                                         :disabled="!data.editable"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="采购价" width="110" required>
                            <template #default="{data}">
                                <c-input name="purchase_price" v-model="data.purchase_price" type="number" decimal="2"
                                         :range="[0,999999]" placeholder="采购价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="同行价" width="110">
                            <template #default="{data}">
                                <c-input name="market_price" v-model="data.market_price" type="number" decimal="2" :range="[0,999999]"
                                         placeholder="同行价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="零售价" width="110">
                            <template #default="{data}">
                                <c-input name="retail_price" v-model="data.retail_price" type="number" decimal="2" :range="[0,999999]"
                                         placeholder="零售价" append-text="元"
                                         :disabled="!data.editable" :clear="false"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column label="备注" width="100">
                            <template #default="{data}">
                                <c-input name="remark" v-model="data.remark" maxlength="100"
                                         :disabled="!data.editable"></c-input>
                            </template>
                        </c-table-column>
                        <c-table-column type="button" label="操作" width="80">
                            <template #default="row">
                                <c-table-button v-if="auth('b_online_purchase_check') && row.data.editable == 1" :disabled="!purchase_order_id || !row.data.id" icon="tf-checkout" @click="$refs.productUniqueCodeCheck.open(false,row.data);">初检</c-table-button>
                                <c-table-button color="red" v-if="auth('b_online_purchase_order_edit') && row.data.editable == 1" icon="tf-trash" @click="removeRow(row);">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </module-tab>
            </module-col>
        </module>

        <template #button>
            <c-button v-if="purchase_state == 2" color="gray" size="dialog" @click="submitHandle(2)">暂存</c-button>
            <c-button color="main" size="dialog" @click="submitHandle(3)">确认</c-button>
        </template>
        <!--唯一码初检弹窗-->
        <product-unique-code-check ref="productUniqueCodeCheck" @resolve="checkResolve"></product-unique-code-check>
    </c-dialog>
</template>
<script>
import productUniqueCodeCheck from "@/pages/product/product_unique_code_check.vue";
import {mapState} from "vuex";

export default {
    name: 'onlinePurchaseEdit',
    props: {
        operation_type: [String, Number]        //操作类型 1=确认收货 2=编辑
    },
    components: {productUniqueCodeCheck},

    computed: {
		...mapState(['yesOrNoOptions']),
        //是否还允许添加背贴码
        canAddCode() {
            var productCount = 0;
            if (this.$refs.productTable){
                var product_list = this.$refs.productTable.getData();
                if (product_list && product_list.length > 0){
                    productCount = product_list.length;
                }
            }
            if (productCount >= this.purchase_product_count){
                return false;
            }
            return true;
        }
    },
    data() {
        return {
            //采购状态（1：待收货，2：质检中，3：待确认，4：已确认，5：部分入库，6：已入库，7：已取消）
            purchase_state:2,
            detailData:{},
            purchase_order_id: 0,
            purchaseDepOptions: [],//已选中的采购部门
            purchaseDeptId:0,    //采购部门
            scanCode: '',        //扫码输入的背贴码
            imiePoints: 0,       //IMEI查询积分余额
            purchase_product_count:0,//采购总数
        }
    },

    methods: {
        //打开弹窗
        open(data) {
            this.deleteProductList = [];
            this.scanCode = '';
            this.loadImiePoints();
            if (data && data.id) {
                this.purchase_order_id = data.id;
                this.getPurchaseOrderDetail();
                this.focusInput();
            }
            this.$refs.dialog.open({
                title: this.operation_type==2 ? '编辑线上采购单' : '线上采购单确认收货'
            });
        },
        /*********扫码/输入背贴码处理**********/
        scanHandle() {
            var code = this.scanCode.trim();
            if (!code) {
                this.$message({message: '请输入背贴码', type: 'warn'});
                return;
            }
            // 获取当前表格数据
            var productList = this.$refs.productTable.getData() || [];
            // 检查是否已存在
            if (productList.some(item => item.produce_unique_code == code)) {
                this.$message({message: '该背贴码已添加', type: 'warn'});
                this.scanCode = '';
                this.focusInput();
                return;
            }
            this.request({
                url: '/productCode/queryByCode',
                data: {
                    produce_unique_code: code
                },
                loading: true,
                success: data => {
                    if (data.main_state != 1) {
                        this.$message({message: '当前商品主状态非【待绑定】，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$message({message: '当前背贴码已关联其他采购单，无法添加', type: 'warn'});
                        this.scanCode = '';
                        this.focusInput();
                        return;
                    }
                    // 构建行数据
                    var rowData = {};
                    rowData.editable = 1;
                    rowData.code_checked = data.produce_unique_code || code;//已通过接口校验的背贴码
                    rowData.produce_unique_code = data.produce_unique_code || code;
                    rowData.produce_imei = data.produce_imei || '';
                    rowData.category_id = data.category_id || '';
                    rowData.brand_id = data.brand_id || '';
                    rowData.spu_model_id = data.spu_model_id || '';
                    rowData.memory_id = data.memory_id || '';
                    rowData.color_id = data.color_id || '';
                    rowData.level_type = data.level_type || '';
                    rowData.is_demo = data.is_demo || 2;//是否演示机（1-是 2-否）
                    rowData.out_order_number = data.out_order_number || '';
                    rowData.purchase_price = data.purchase_price || undefined;
                    rowData.market_price = data.market_price || undefined;
                    rowData.retail_price = data.retail_price || undefined;
                    rowData.inspection_state = 1;
                    rowData.remark = data.remark || '';
                    // 下拉选项回显
                    rowData.productCategory = data.category_name ? [{name: data.category_name, value: data.category_id}] : [];
                    rowData.productBrand = data.brand_name ? [{name: data.brand_name, value: data.brand_id}] : [];
                    rowData.productModel = data.spu_model_name ? [{name: data.spu_model_name, value: data.spu_model_id}] : [];
                    rowData.productMemory = data.memory_name ? [{name: data.memory_name, value: data.memory_id}] : [];
                    rowData.productColor = data.color_name ? [{name: data.color_name, value: data.color_id}] : [];
                    rowData.productLevel = data.level_name ? [{name: data.level_name, value: data.level_type}] : [];
                    this.$refs.productTable.push(rowData);
                    this.scanCode = '';
                    this.focusInput();
                },
                fail: (code, obj, message) => {
                    this.$message({message: message || '背贴码校验失败，请检查', type: 'warn'});
                    this.scanCode = '';
                    this.focusInput();
                    return false;//已自行提示，不再触发全局弹窗
                }
            });
        },
        /*********清除行内背贴码校验错误提示**********/
        clearCodeError(rowData) {
            if (rowData.code_error) {
                this.$set(rowData, 'code_error', '');
            }
        },
        /*********行内背贴码校验（编辑时直接调用后端接口）**********/
        checkProductCode(rowData) {
            var code = (rowData.produce_unique_code || '').trim();
            if (!rowData.editable) {
                return;
            }
            //正在校验中或已校验通过且值未变化时，不重复请求
            if (rowData.code_checking || (code && rowData.code_checked === code)) {
                return;
            }
            this.$set(rowData, 'code_error', '');
            if (!code) {
                return;
            }
            //本地查重：与商品列表中其他行重复
            var productList = this.$refs.productTable.getData() || [];
            if (productList.filter(item => (item.produce_unique_code || '').trim() == code).length > 1) {
                this.$set(rowData, 'code_error', '该背贴码已存在于商品列表中');
                return;
            }
            this.$set(rowData, 'code_checking', true);
            this.request({
                url: '/productCode/queryByCode',
                data: {
                    produce_unique_code: code
                },
                success: data => {
                    if (data.main_state != 1 && data.main_state != 2) {
                        this.$set(rowData, 'code_error', '当前商品主状态非【待绑定】，无法添加');
                        return;
                    }
                    if (data.purchase_order_id && data.purchase_order_id!= this.purchase_order_id) {
                        this.$set(rowData, 'code_error', '当前背贴码已关联其他采购单，无法添加');
                        return;
                    }
                    //校验通过，记录已校验的值，避免重复请求
                    this.$set(rowData, 'code_checked', code);
                    this.$set(rowData, 'code_error', '');
                },
                fail: (code, obj, message) => {
                    //错误显示在行内输入框下方，不再触发全局弹窗
                    this.$set(rowData, 'code_error', message || '背贴码校验失败，请检查');
                    return false;
                },
                complete: () => {
                    this.$set(rowData, 'code_checking', false);
                }
            });
        },
        /*********背贴码输入框聚焦**********/
        focusInput() {
            this.$nextTick(() => {
                if (this.$refs.codeInput) {
                    this.$refs.codeInput.focus();
                }
            });
        },
        /*********加载当前商户IMEI查询积分余额**********/
        loadImiePoints() {
            this.request({
                url: '/sys_saas/account/info',
                success: data => {
                    if (data) {
                        this.imiePoints = data.imie_points || 0;
                    }
                }
            });
        },
        /*********生成IMEI码并回填当前行**********/
        generateImei(rowData) {
            if (rowData.imei_generating) {
                return;
            }
            this.$set(rowData, 'imei_generating', true);
            this.request({
                url: '/imei/generate',
                loading: true,
                success: data => {
                    this.$set(rowData, 'produce_imei', data);
                },
                complete: () => {
                    this.$set(rowData, 'imei_generating', false);
                }
            });
        },
        /*********打开IMEI出厂信息查询弹窗**********/
        openImeiFactoryQuery() {
            this.$message({
                message: '功能开发中'
            });
            /*var refresh = () => {
                this.loadImiePoints();
            };
            this.globalDialog('imeiFactoryQueryDialog', {}, refresh, refresh);*/
        },

        /**************变更 下拉框数据******************/
        changeSelect(selectData, rowData, type) {
            if (type == 'categoryId') {
                if (selectData) {
                    rowData.productBrand = [];
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.brand_id = '';
                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'brandId') {
                if (selectData) {
                    rowData.productModel = [];
                    rowData.productMemory = [];
                    rowData.productLevel = [];

                    rowData.spu_model_id = '';//型号
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            } else if (type == 'modelId') {
                if (selectData) {
                    rowData.productMemory = [];
                    rowData.productLevel = [];
                    rowData.memory_id = '';//内存ID
                    rowData.color_id = '';//颜色ID
                }
            }
        },

        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索品牌****************/
        searchBrand(data, keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: data.category_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索机型****************/
        searchModel(data, keyword, resolve) {
            this.request({
                url: '/spu/model/options',
                data: {
                    category_id: data.category_id,
                    brand_id: data.brand_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchSpuAttribute(rowData, attribute_code, keyword, resolve) {
            this.request({
                url: '/spu/attribute/value/options',
                data: {
                    attribute_code: attribute_code,
                    model_id: rowData.spu_model_id,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchDicInfo(dic_type_code, keyword, resolve) {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: dic_type_code,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索采购订单详情*******************/
        getPurchaseOrderDetail() {
            this.request({
                url: '/purchase/order/detail',
                data: {
                    purchase_order_id: this.purchase_order_id
                },
                loading: true,
                success: data => {
                    this.detailData = data.detailInfo;
                    this.purchase_state = this.detailData.purchase_state;
                    this.purchase_product_count = this.detailData.purchase_product_count?this.detailData.purchase_product_count:this.detailData.purchase_count;
                    //加载工单列表
                    var productList = data.productList || [];
                    productList.forEach(item => {
                        if (!item.is_demo) item.is_demo = 2;//存量数据无该字段，默认非演示机
                    });
                    this.$refs.productTable.setData(productList);
                }
            });
        },

        /**
         * 初检完成后：刷新本弹窗采购单详情，并通知打开本弹窗的外层列表刷新
         */
        checkResolve() {
            this.getPurchaseOrderDetail();
            this.$emit('resolve');
        },

        /******添加行数据*********/
        addRow() {
            var rowData = {};
            rowData.editable = 1;//允许编辑
            rowData.produce_unique_code = '';//背贴码
            rowData.produce_imei = '';//商品国际移动设备识别码(唯一)
            rowData.category_id = '';//分类ID
            rowData.brand_id = '';//品牌ID
            rowData.spu_model_id = '';//机型ID
            rowData.memory_id = '';//内存ID
            rowData.color_id = '';//颜色ID
            rowData.level_type = '';      //等级ID
            rowData.is_demo = 2;          //是否演示机（1-是 2-否）
            rowData.out_order_number = '';//外部订单号
            rowData.purchase_price = undefined;//采购单价
            rowData.market_price = undefined;//同行价（元）
            rowData.retail_price = undefined;//零售价（元）
            rowData.inspection_state = 1;//初检状态（1：待完善，2：已完善）
            rowData.remark = '';//备注
            this.$refs.productTable.push(rowData)
        },
        /******删除行数据*********/
        removeRow(row) {
            if (row.data.id) {
                this.$confirm({
                    type: 'warn',
                    message: (row.data.produce_unique_code ? '是否确认删除背贴码【' + row.data.produce_unique_code + '】' : '是否确认删除选中数据行'),
                    buttonName: '确认删除',
                    resolve: () => {
                        row.remove();
                    }
                });
            } else {
                row.remove();
            }
        },
        /*******提交编辑数据********************/
        submitHandle(purchase_state) {
            var flag = true;
            //产品工单列表
            var product_list = this.$refs.productTable.getData();
            if (product_list.length == 0) {
                this.$message({
                    message: '请至少添加一件采购商品',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            //背贴码正在校验中
            if (product_list.some(item => item.code_checking)) {
                this.$message({
                    message: '背贴码正在校验中，请稍候',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            //存在校验未通过的背贴码
            if (product_list.some(item => item.code_error)) {
                this.$message({
                    message: '存在校验未通过的背贴码，请修正后重试',
                    type: 'warn'
                });
                flag = false;
                return;
            }
            product_list.forEach(item => {
                if (!item.produce_unique_code || !item.produce_imei
                        || !item.category_id || !item.brand_id || !item.spu_model_id
                        || !item.memory_id || !item.color_id || !item.level_type
                        || !item.purchase_price) {
                    this.$message({
                        message: '请完善采购商品必填项',
                        type: 'warn'
                    });
                    flag = false;
                    return;
                }
            });
            //存在重复的IMEI码
            var imeiList = product_list.map(item => (item.produce_imei || '').trim()).filter(imei => !!imei);
            var repeatImeis = imeiList.filter((imei, index) => imeiList.indexOf(imei) < index && imeiList.lastIndexOf(imei) == index);
            if (repeatImeis.length > 0) {
                this.$message({
                    message: '存在重复的IMEI码：' + repeatImeis.join('、'),
                    type: 'warn'
                });
                flag = false;
                return;
            }
            if (purchase_state == 3){
                /*product_list.forEach(item => {
                    if (item.inspection_state != 2) {
                        this.$message({
                            message: '所有商品完成初检后才能确认线上采购单',
                            type: 'warn'
                        });
                        flag = false;
                        return;
                    }
                });*/
                if ( this.purchase_product_count != product_list.length){
                    this.$message({
                        message: '采购数必须与采购商品明细行数一致',
                        type: 'warn'
                    });
                    flag = false;
                    return;
                }
            }
            if (flag){
                this.request({
                    url: this.operation_type == 1 ? '/online/purchase/order/receipt' : '/online/purchase/order/edit',
                    data: {
                        purchase_state:purchase_state,
                        purchase_product_count:this.purchase_product_count,
                        purchase_order_id: this.purchase_order_id,
                        product_list:product_list.map(item => {
                            if(!item.market_price || item.market_price == ''){
                                item.market_price = undefined;
                            }
                            if(!item.retail_price || item.retail_price == ''){
                                item.retail_price = undefined;
                            }
                            //移除背贴码校验的辅助字段
                            delete item.code_error;
                            delete item.code_checked;
                            delete item.code_checking;
                            delete item.imei_generating;
                            return item;
                        })
                    },
                    success: data => {
                        this.$message({
                            type: 'success',
                            message: this.operation_type == 1 ? '线上采购单确认收货成功' : '编辑线上采购单成功',
                        });
                        //刷新页面
                        this.$emit('resolve');
                        if (purchase_state != 2 ){
                            this.$refs.dialog.close();
                        }else {
                            //刷新页面数据
                            this.purchase_order_id = data;
                            this.getPurchaseOrderDetail();
                        }
                    }
                })
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .m-balance-text
        margin-left 10px
        color #666
        font-size 12px

    .m-code-error-tip
        margin-top 2px
        color red
        font-size 12px
        line-height 16px
        word-break break-all
        white-space normal
        word-break break-all
        overflow-wrap break-word

    .m-gen-imei
        padding 0 6px
        font-size 12px
        color var(--color-main)
        line-height 30px
        white-space nowrap
        cursor pointer
        &.z-dis
            color #999
            cursor not-allowed
</style>